import React, {useContext, useMemo} from 'react';
import dayjs from "dayjs";
import {PlayerContext} from "../../../shared/contexts/playerContext";
import LogTemplate from "../../logs/LogTemplate";
import {getProfileLogColumns} from "../../logs/columns/profileLogColumns";
import {useProfileData} from "../../logs/useTableData";

const PlayerProfileLog = () => {
    const {playerData} = useContext(PlayerContext);
    const {data: profileData} = useProfileData();

    const defaultSearchParams = {
        begin: dayjs().subtract(3, 'day').startOf('day').unix(),
        end: dayjs().endOf('day').unix(),
        pid: playerData.pid,
        logType: 'RQProfileLog',
        isUnix: true
    };

    const columns = useMemo(() => getProfileLogColumns(profileData), [profileData]);

    return (
        <div>
            <LogTemplate
                columns={columns}
                defaultSearchParams={defaultSearchParams}
                routerUrl={'/logs/operation'}
                log={'operation'}
            />
        </div>
    );
};

export default PlayerProfileLog;
